import React from 'react';
import './InvalidLinkComponent.less';
import PropTypes from 'prop-types';
import {ButtonLink} from '@homeaway/react-buttons';

export default class InvalidLinkComponent extends React.Component {
    static get propTypes() {
        return {
            lingua: PropTypes.shape({read: PropTypes.func, exists: PropTypes.func}),
            handleResendLink: PropTypes.func
        };
    }

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="InvalidLinkComponent text-center">
                <div className="SvgImage">
                    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65">
                        <g fill="none" fillRule="evenodd">
                            <path fill="#DE0B0B" d="M33.5 41.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001"/>
                            <path stroke="#DE0B0B" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
                                d="M32 17.607v17.452M64 32.427C64 49.862 49.862 64 32.427 64 14.99 64 .853 49.862.853 32.427.853 14.99 14.991.853 32.427.853 49.862.853 64 14.991 64 32.427z"
                            />
                        </g>
                    </svg>
                </div>
                <div><h2 className="Header">{this.props.lingua.read('lex.ticket.confirm')}</h2></div>
                <p className="InvalidLinkTitle">{this.props.lingua.read('lex.ticket.invalid')}</p>
                <ButtonLink label={this.props.lingua.read('lex.ticket.resend')} onClick={this.props.handleResendLink}/>
            </div>
        );
    }
}
